import React from "react";
import styled from "styled-components";

// import { BhLogin } from "../../DivWrapperScreen/login/login";

const StyledElement = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;

a {
  cursor: default; /* 기본 포인터 모양으로 변경 */
  text-decoration: none; /* 필요 시 링크 밑줄 제거 */
}


& .info-container {
    display: flex;
    flex-direction: row;
    position: absolute;
    width: 500px;
    height: 164px;
    gap: 24px;
    top: 80px;
    left: 862px;
}  

& .info-text {
    display: flex;
    flex-direction: column;
    width: 150.67px;
}

& .info-text-title {
    align-self: stretch;
    color: var(--graygray-700);
    font-family: "Pretendard-Bold", Helvetica;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 28px;
    position: relative;    
    margin-bottom: 19px;
}

& .info-text-contents {
    align-self: stretch;
    color: var(--graygray-700);
    font-family: "Pretendard-Regular", Helvetica;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 28.8px;
    position: relative;
    cursor: pointer;
}

& .subinfo-text-container {
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 1200px;
    height: 50px;
    top: 298.21px;
    left: 162px;
}

& .subinfo-company-area {
    display: flex;
    flex-direction: row; 
    gap: 10px;
}
`;


export const BhHomepage12 = () => {

    return (
        <StyledElement>
            <img className="background-image" alt="background-image" src="/image/Footer.png" />
            <a href="" target="_blank" rel="noopener noreferrer">
            </a>
            <div className="info-container">
                <div className="info-text">
                    <div className="info-text-title">회사</div>
                    <a href="http://www.comfac.kr/comfac" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">회사소개</label>
                    </a>
                    <a href="https://www.saramin.co.kr/zf_user/company-info/view-inner-recruit?csn=RGN6dEVJdHYyOThwVjBOeWZlOFMvdz09" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">인재채용</label>
                    </a>
                </div>

                <div className="info-text">
                    <div className="info-text-title">소셜미디어</div>
                    <a href="https://www.instagram.com/beautyhama.shop?igsh=NmlpOWo1enFwdTVt" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">인스타그램</label>
                    </a>
                    <a href="" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">페이스북</label>
                    </a>
                    <a href="https://blog.naver.com/beauty-hama" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">블로그</label>
                    </a>
                    <a href="https://www.youtube.com/@beautyhama" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">유튜브</label>
                    </a>
                </div>

                <div className="info-text">
                    <div className="info-text-title">고객센터</div>
                    <label className="info-text-contents">원장님 이용 가이드</label>
                    <a href="http://pf.kakao.com/_hlxnjG" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">채팅: 카카오톡</label>
                    </a>
                    <label className="info-text-contents">전화: 02-865-1555</label>
                    <label className="info-text-contents">평일 10:00-17:00</label>
                </div>
            </div>

            <div className="subinfo-text-container">
                <div className="subinfo-company-area">
                    <label className="info-text-contents">사업제휴</label>
                    <label className="info-text-contents">|</label>
                    <a href="https://slashpage.com/beautyhama/dk58wg2ejzjqpmnqevxz" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">개인정보처리방침</label>
                    </a>
                    <a href="https://slashpage.com/beautyhama/7916x82rqwqzjm4kpyg3" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">서비스이용약관</label>
                    </a>
                    <a href="https://slashpage.com/beautyhama/dwy5rvmj131832p46zn9" target="_blank" rel="noopener noreferrer">
                        <label className="info-text-contents">마케팅정보 수신동의</label>
                    </a>
                </div>
                <label className="info-text-contents">컴팩 주식회사 | 대표 : 심재범 | 사업자등록번호 292-88-02847 | 통신판매업신고번호 : 제2024-서울영등포-1604호 |
                    서울시 영등포구 의사당대로 83, 서울핀테크랩 4층(오투타워)
                </label>
            </div>
        </StyledElement>
    );
};
